import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { AttributeResource } from '@df/catalog/attribute/attribute.resource';
import { Client } from '@df/core/service/client';
import { UgcImage } from '@df/ugc-image/ugc-image';
import { GridModule } from '@df/ui/atomic/atom/grid/grid.module';
import { IfSizeDirective } from '@df/ui/common/if-size.directive';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import uniq from 'lodash-es/uniq';
import uniqBy from 'lodash-es/uniqBy';
import { LocalListing } from '../../../catalog/ui/listing/listing.decorator';
import { UgcImageItemComponent } from '../item/ugc-image-item.component';
import { UgcImageService } from '../ugc-image.service';
import { UgcImageGalleryComponent } from './ugc-image-gallery.component';
import { NUgcImageGallery } from './ugc-image-gallery.namespace';
@Component({
    selector: 'ugc-image-gallery-listing',
    templateUrl: './ugc-image-gallery-listing.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CommonModule, TranslatePipe, GridModule, ICmsClientModule, UgcImageItemComponent, IfSizeDirective]
})
export class UgcImageGalleryListingComponent extends UgcImageGalleryComponent implements OnChanges {
    listing?: LocalListing<UgcImage>;
    _gridS: 1 | 2 = 1;
    filterOptions = NUgcImageGallery.roomOptions
    visibleFilterOptions;
    filterSelection: string[] = [];
    @Input()
    override content?: NUgcImageGallery.IListingData;

    constructor(
        protected override ugcImageService: UgcImageService,
        changeDetectorRef: ChangeDetectorRef,
        protected override requestService: RequestService,
        public override client: Client,
        private attributeResource: AttributeResource
    ) {
        super(ugcImageService, changeDetectorRef, requestService, client, undefined as any);
    }

    protected finish(ugcImages: UgcImage[]) {
        const shownUgcImages = this.content?.showLimit ? ugcImages.slice(0,this.content.showLimit) : ugcImages;
        if (this.listing) {
            this.listing.setSourceModels(shownUgcImages)
        } else {
            this.listing = new LocalListing<UgcImage>(
                {
                    type: 'ugcImage',
                    infScrollStep: this.content?.infScrollStep,
                    initialStepsVisible: this.content?.initialStepsVisible,
                    storage: false
                },
                shownUgcImages,
                {
                    filtersDefinitions: ['ugc_category']
                }
            );
        }
        const visibleFilterOptionValues = uniq(ugcImages.map(i => i.data?.room));
        this.visibleFilterOptions = this.filterOptions.filter(i => !i.key || visibleFilterOptionValues.includes(i.key));
        this.detectChanges();
    }
    increaseLimit(): void {
        this.listing?.increaseLimit();
        this.detectChanges();
    }

    get modelsWithoutDuplicates(): UgcImage[] {
        return uniqBy(this.listing?.models || [], model => model.data?.image);
    }

    toggleFilterOption(option: string) {
        if (!option) {
            this.filterSelection = [];
        } else {
            if (this.isFilterOptionSelected(option)) {
                this.filterSelection = this.filterSelection.filter(i => i !== option);
            } else {
                this.filterSelection.push(option);
            }
        }
        if (!this.filterSelection.length) {
            this.listing?.overrideFilteredModels(this.listing?.getModelsBare() || []);
        } else {
            this.listing?.overrideFilteredModels(
                (this.listing?.getModelsBare() || []).filter(i => this.filterSelection.includes((<any>i.data)?.room))
            );
        }
        this.detectChanges();
    }

    isFilterOptionSelected(option?: string) {
        return this.filterSelection.includes(option as string) || (!this.filterSelection.length && !option);
    }

    get modelsFiltered() {
        if (!this.filterSelection.length) {
            return this.listing?.models;
        } else {
            return this.listing?.models.filter(i => this.filterSelection.includes((<any>i.data)?.room));
        }
    }
}
